<template>
  <div>
    <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
      <div class="content">
        <section class="section--sidebar-user">

          <section class="section--content-sidebar section--content-sidebar-full-height">
            <form method="POST" id="question29Form" :action="this.action" accept-charset="UTF-8"
              enctype="multipart/form-data" class="workflow-tabs">
              <div class="tab-content">
                <input type="hidden" name="_token" :value="csrf" />
                <input v-if="this.editing" type="hidden" name="_method" value="PUT" />


                <div class="row mb-3">
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label>{{ __("forms.Question.title") }}</label>
                      <input type="text" class="form-control rounded" name="questionBase[name]" :value="this.name" />
                    </div>
                  </div>

                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label>{{ __("forms.Question.description") }}</label>
                      <input type="text" class="form-control rounded" name="questionBase[description]"
                        :value="this.description" />
                    </div>
                  </div>
                  <div class="col-12 col-md-3">
                    <div class="form-group">
                      <label>{{ __("forms.Question.sorting") }}</label>
                      <input type="number" class="form-control rounded" name="questionBase[sorting]"
                        :value="this.sorting" />
                    </div>
                  </div>

                </div>


                <!--          PART 1-->
                <div class="alert alert-warning" role="alert">
                  {{ __("forms.EvaluationChart.questions.questions_setting.question29.alertQuestionOutput") }}
                </div>
                <div class="row mb-3">
                  <div class="col-12 col-md-3">
                    <div class="form-group">
                      <label>{{
                        __("forms.EvaluationChart.questions.questions_setting.question29.minLimitRep")
                      }}</label>
                      <input type="number" required class="form-control rounded" min="0" max="100"
                        name="questionSettings[repartitioning_min_value]" :value="this.repartitioning_min_value" />
                    </div>
                  </div>
                  <div class="col-12 col-md-3">
                    <div class="form-group">
                      <label>{{
                        __("forms.EvaluationChart.questions.questions_setting.question29.maxLimitRep")
                      }}</label>
                      <input type="number" class="form-control rounded" required min="0" max="100"
                        name="questionSettings[repartitioning_max_value]" :value="this.repartitioning_max_value" />
                    </div>
                  </div>
                  <div class="col-12 col-md-3">
                    <div class="form-group">
                      <label>{{
                        __("forms.EvaluationChart.questions.questions_setting.question29.methodCalculation")
                      }}</label>
                      <select class="form-control" v-model="method_calculation"
                        name="questionSettings[method_calculation]">
                        <option value="method_sum_plain">
                          {{
                            __("forms.EvaluationChart.questions.questions_setting.question29.methodCalculationSumPlain")
                          }}
                        </option>
                        <option value="method_sum_weighted">
                          {{
                            __("forms.EvaluationChart.questions.questions_setting.question29.methodCalculationSumWeight")
                          }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="custom-control custom-switch">
                      <input name="questionSettings[show_graph]" type="checkbox" class="custom-control-input"
                        id="questionSettings[show_graph]" value="1" v-model="this.show_graph">
                      <label class="custom-control-label" for="questionSettings[show_graph]">{{
                        __("forms.EvaluationChart.questions.questions_setting.question29.showGraph")
                      }}</label>
                    </div>
                  </div>

                  <div class="col-4">
                    <div class="custom-control custom-switch">
                      <input name="questionSettings[show_avg_weight]" type="checkbox" class="custom-control-input"
                        id="questionSettings[show_avg_weight]" value="1" v-model="this.show_avg_weight">
                      <label class="custom-control-label" for="questionSettings[show_avg_weight]">{{
                        __("forms.EvaluationChart.questions.questions_setting.question29.showWeights")
                      }}</label>
                    </div>
                  </div>
                  <div class="col-4">
                    <div class="custom-control custom-switch">
                      <input name="questionSettings[show_percent_symbol]" type="checkbox" class="custom-control-input"
                        id="questionSettings[show_percent_symbol]" value="1" v-model="this.show_percent_symbol">
                      <label class="custom-control-label" for="questionSettings[show_percent_symbol]">{{
                        __("forms.EvaluationChart.questions.questions_setting.question29.showPercentSymbol")
                      }}</label>
                    </div>
                  </div>

                </div>
                <div class="row mb-3">
                  <div class="col-12">
                    <p class="tab-description mt-3 mb-2">
                      {{ __("forms.EvaluationChart.questions.questions_setting.question29.availableSources") }}</p>
                  </div>
                </div>
                <div class="row mb-3">
                  <div class="col-2">
                    <label class="h6">{{
                      __("forms.EvaluationChart.questions.questions_setting.question29.type")
                    }}</label>
                  </div>
                  <div class="col-3">
                    <label class="h6">{{
                      __("forms.EvaluationChart.questions.questions_setting.question29.question")
                    }}</label>
                  </div>
                  <div class="col-3">
                    <label class="h6">{{
                      __("forms.EvaluationChart.questions.questions_setting.question29.label")
                    }}</label>
                  </div>
                  <div class="col-1">
                    <label v-if="method_calculation == 'method_sum_weighted'" class="h6">{{
                      __("forms.EvaluationChart.questions.questions_setting.question29.weight")
                    }}</label>
                    <label v-else class="h6" style="text-decoration: line-through;">{{
                      __("forms.EvaluationChart.questions.questions_setting.question29.weight")
                    }}</label>
                  </div>

                  <div class="col-1">
                    <label class="h6">{{
                      __("forms.EvaluationChart.questions.questions_setting.question29.range")
                    }}</label>
                  </div>
                  <div class="col-1">
                    <label class="h6">{{
                      __("forms.EvaluationChart.questions.questions_setting.question29.rep")
                    }}</label>
                  </div>
                  <div class="col-1">
                    <label class="h6">{{
                      __("forms.EvaluationChart.questions.questions_setting.question29.index")
                    }}</label>
                  </div>
                </div>
                <div v-for="(source, i) in sources" class="row mb-1" :key="i">
                  <input type="hidden" :name="'questionSettings[sources][' + source.element + '][question_survey_id]'"
                    :value="source.question_survey_id" />
                  <input type="hidden" :name="'questionSettings[sources][' + source.element + '][question_id]'"
                    :value="source.question_id" />
                  <div class="col-2">

                    <div class="custom-control custom-switch">
                      <input :name="'questionSettings[sources][' + source.element + '][selected]'" type="checkbox"
                        class="custom-control-input" :id="'questionSettings[sources][' + source.element + '][selected]'"
                        value="1" v-model="source.selected" @change="handleSourceChange(source)">
                      <label class="custom-control-label"
                        :for="'questionSettings[sources][' + source.element + '][selected]'">
                        {{ source.question_type }}
                      </label>
                    </div>
                  </div>
                  <div class="col-3">
                    {{ source.question_name }}
                  </div>
                  <div class="col-3">
                    <input class="form-control" type="text" :name="'questionSettings[sources][' +
                      source.element +
                      '][name]'
                      " v-model="source.name" />
                  </div>
                  <div class="col-1">
                    <input v-if="method_calculation == 'method_sum_weighted'" type="number" class="form-control" min="0"
                      max="100" step="0.01" :name="'questionSettings[sources][' + source.element + '][weight]'"
                      v-model="source.weight" />
                    <input v-else type="hidden" v-model="source.weight"
                      :name="'questionSettings[sources][' + source.element + '][weight]'">
                  </div>
                  <div class="col-1">
                    <label class="mt-2">
                      {{ source.rangeValues }}
                    </label>

                  </div>
                  <div class="col-1">


                    <div class="custom-control custom-switch">
                      <input :name="'questionSettings[sources][' + source.element + '][repartition]'" type="checkbox"
                        class="custom-control-input"
                        :id="'questionSettings[sources][' + source.element + '][repartition]'" value="1"
                        v-model="source.repartition">
                      <label class="custom-control-label"
                        :for="'questionSettings[sources][' + source.element + '][repartition]'">Attiva</label>
                    </div>

                  </div>
                  <div class="col-1">
                    <input class="form-control" type="number" min="0" max="100"
                      :name="'questionSettings[sources][' + source.element + '][index_sort]'"
                      v-model="source.index_sort" />
                  </div>
                </div>

                <!--          PART 2-->
                <div v-if="method_calculation == 'method_sum_weighted'">
                  <p class="tab-description mt-3 mb-2">
                    {{ __("forms.EvaluationChart.questions.questions_setting.question29.reAdaptTitle") }}
                  </p>
                  <div class="alert alert-warning" role="alert">
                    {{ __("forms.EvaluationChart.questions.questions_setting.question29.alertReAdapt") }}
                  </div>
                  <div class="row mb-3">

                    <div class="col-4 col-md-4">
                      <label>{{
                        __("forms.EvaluationChart.questions.questions_setting.question29.reAdaptQuestionSurveyZero")
                      }}</label>
                      <select class="form-control" v-model="newReAdaptQuestionSurveyZero">
                        <option value="">---</option>
                        <option v-for="(source, i) in sources" class="row mb-1" :key="i" :value="source.element">
                          {{ source.question_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-4 col-md-4">
                      <label>{{
                        __("forms.EvaluationChart.questions.questions_setting.question29.reAdaptQuestionSurveyCover")
                      }}</label>
                      <select class="form-control" v-model="newReAdaptQuestionSurveyCover">
                        <option value="">---</option>
                        <option v-for="(source, i) in sources" class="row mb-1" :key="i" :value="source.element">
                          {{ source.question_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-3 col-md-3">
                      <label>{{
                        __("forms.EvaluationChart.questions.questions_setting.question29.reAdaptPercent")
                      }}</label>
                      <input class="form-control" v-model="newReAdaptPercent" type="number" min="0" max="100">
                    </div>
                    <div class="col-1 col-md-1 mt-4">

                      <button @click="addReAdaptRow()" type="button"
                        class="btn btn--mini btn--only-icon btn--transparent circle-button-edit">
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                  <hr>
                  <div class="row mt-0" v-for="(row, indexRow) in reAdapt">
                    <div class="col-4 col-md-4">
                      <select class="form-control" v-model="row.questionSurveyZero" required
                        :name="'questionSettings[reAdapt][' + indexRow + '][questionSurveyZero]'">
                        <option value="">---</option>
                        <option v-for="(source, i) in sources" class="row mb-1" :key="i" :value="source.element">
                          {{ source.question_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-4 col-md-4">
                      <select class="form-control" v-model="row.questionSurveyCover" required
                        :name="'questionSettings[reAdapt][' + indexRow + '][questionSurveyCover]'">
                        <option value="">---</option>
                        <option v-for="(source, i) in sources" class="row mb-1" :key="i" :value="source.element">
                          {{ source.question_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-3 col-md-3">
                      <input class="form-control" v-model="row.questionSurveyPercent" type="number" min="0" max="100"
                        required :name="'questionSettings[reAdapt][' + indexRow + '][questionSurveyPercent]'">
                    </div>
                    <div class="col-1 col-md-1">
                      <button @click="rmReAdaptRow(indexRow)" type="button"
                        class="btn btn--mini btn--only-icon btn--transparent circle-button-remove">
                        <i class="fas fa-trash-alt"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <!--PART 3-->
                <div v-if="method_calculation == 'method_sum_weighted'">
                  <div>
                    <p class="tab-description mt-3 mb-2">
                      {{ __("forms.EvaluationChart.questions.questions_setting.question29.dynamicWeight") }}
                    </p>
                    <div class="alert alert-warning" role="alert">
                      {{
                        __("forms.EvaluationChart.questions.questions_setting.question29.alert_messages.alertDynamicWeight")
                      }}
                    </div>
                  </div>
                  <div class="row mb-3">
                    <div class="col-2 col-md-2">
                      <label>{{
                        __("forms.EvaluationChart.questions.questions_setting.question29.dynamicWeightType")
                      }}</label>
                      <select class="form-control" v-model="dynamicReAdaptType">
                        <option value="">---</option>
                        <option v-for="(dynamic_type, i) in dynamic_types" class="row mb-1" :key="i" :value="i">
                          {{ dynamic_type }}
                        </option>
                      </select>
                    </div>
                    <div class="col-3 col-md-3">
                      <label>{{
                        __("forms.EvaluationChart.questions.questions_setting.question29.allPossibleFilters")
                      }}</label>
                      <select class="form-control" v-model="dynamicReAdaptOption">
                        <option value="">---</option>
                        <option v-if="dynamicReAdaptType == 'roles'" v-for="(role, i) in roles" class="row mb-1"
                          :key="i" :value="role.id">
                          {{ role.name }}
                        </option>
                        <option v-if="dynamicReAdaptType == 'rolesFamily'" v-for="(roleFamily, i) in rolesFamily"
                          class="row mb-1" :key="i" :value="roleFamily.id">
                          {{ roleFamily.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-1 col-md-1 mt-4">

                      <button @click="addDynamicReAdaptRow()" type="button"
                        class="btn btn--mini btn--only-icon btn--transparent circle-button-edit">
                        <i class="fas fa-plus"></i>
                      </button>
                    </div>
                  </div>
                  <hr>
                  <div class="row mt-0" v-for="(row, indexRow) in dynamicReAdapt">
                    <div class="col-4 col-md-4">
                      <select readonly="readonly" class="form-control" v-model="row.questionSurveyZero" required
                        :name="'questionSettings[dynamicReAdapt][' + indexRow + '][questionSurveyZero]'"
                        style="pointer-events: none; cursor: not-allowed;">
                        <option v-for="(source, i) in filterSources('questionSurveyZero', row.questionSurveyZero)"
                          class="row mb-1" :key="i" :value="source.element">
                          {{ source.question_name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-2 col-md-2">
                      <select readonly="readonly" class="form-control" v-model="row.questionType" required
                        :name="'questionSettings[dynamicReAdapt][' + indexRow + '][questionType]'"
                        style="pointer-events: none; cursor: not-allowed;">
                        <option v-for="(dynamic_type, i) in dynamic_types" class="row mb-1" :key="i" :value="i">
                          {{ dynamic_type }}
                        </option>
                      </select>
                    </div>
                    <div class="col-3 col-md-3">

                      <select readonly="readonly" class="form-control" v-model="row.questionOption" required
                        :name="'questionSettings[dynamicReAdapt][' + indexRow + '][questionOption]'"
                        style="pointer-events: none; cursor: not-allowed;">
                        <option v-for="(roleFamily, i) in filterSources('questionOption', row.questionOption)"
                          class="row mb-1" :key="i" :value="roleFamily.id">
                          {{ roleFamily.name }}
                        </option>
                      </select>
                    </div>
                    <div class="col-2 col-md-2">
                      <input class="form-control" v-model="row.questionSurveyPercent" type="number" min="0" max="100"
                        required :name="'questionSettings[dynamicReAdapt][' + indexRow + '][questionSurveyPercent]'">
                    </div>
                    <div class="col-1 col-md-1">
                      <button @click="rmDynamicReAdaptRow(indexRow)" type="button"
                        class="btn btn--mini btn--only-icon btn--transparent circle-button-remove">
                        <i class="fas fa-trash-alt"></i>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="row mt-5">
                  <div class="col-12">
                    <p class="tab-description mt-3 mb-2">Fascia di risultato ( se X < index=> Value)</p>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12">
                    <div class="row" v-for="(row, index) in result_band_settings" :key="'band_' + index">
                      <div class="col-3">
                        <label>{{ __("forms.EvaluationChart.questions.questions_setting.question24.index") }}</label>
                        <input class="form-control rounded"
                          :name="'questionSettings[result_band_settings][' + index + '][index]'" required
                          :value="row.index">
                      </div>
                      <div class="col-3">
                        <label>{{ __("forms.EvaluationChart.questions.questions_setting.question24.outcome") }}</label>
                        <input class="form-control rounded"
                          :name="'questionSettings[result_band_settings][' + index + '][label]'" required
                          :value="row.label">
                      </div>
                      <div class="col-6">
                        <button type="button" class="btn btn--only-icon-rounded btn--danger float-right"
                          @click="deleteRating(index)"><i class="fas fa-times"></i></button>
                      </div>

                    </div>
                  </div>
                </div>

                <div class="row mt-5">
                  <div class="col-12">
                    <p class="tab-description mt-3 mb-2">
                      {{ __("forms.EvaluationChart.questions.questions_setting.question24.add_rating") }}
                    </p>
                  </div>
                </div>

                <div class="row mb-3">
                  <div class="col-3">
                    <label>{{ __("forms.EvaluationChart.questions.questions_setting.question24.index") }}</label>
                    <input class="form-control rounded" type="number" v-model="newBandIndex">
                  </div>
                  <div class="col-3">
                    <label>{{ __("forms.EvaluationChart.questions.questions_setting.question24.label") }}</label>
                    <input class="form-control rounded" type="text" v-model="newBandLabel">
                  </div>
                  <div class="col-6">
                    <button type="button" class="btn float-right" @click="addRating()">
                      {{ __("misc.add") }}
                    </button>
                  </div>
                </div>
                <!--   SAVE -->
                <div class="row">
                  <div class="col-12">
                    <hr>
                  </div>
                  <div class="col-12 mt-3 text-right" v-if="can_write">
                    <button class="btn btn-next" type="submit">{{ __('misc.save') }}</button>
                  </div>
                </div>
              </div>
            </form>
          </section>
        </section>
      </div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  props: {
    can_write: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {

      oldStep: 1,
      //---
      newReAdaptQuestionSurveyZero: null,
      newReAdaptQuestionSurveyCover: null,
      newReAdaptPercent: null,
      //---
      dynamicReAdaptQuestionSurveyZero: null,
      dynamicReAdaptType: null,
      dynamicReAdaptOption: null,
      dynamicReAdaptPercent: null,
      //---
      newBandIndex: 0,
      newBandLabel: "",
      show_percent_symbol: 0,
      repartitioning_min_value: 0,
      show_graph: 0,
      show_avg: 0,
      show_avg_weight: 0,
      repartitioning_max_value: 100,
      reAdapt: {},
      dynamicReAdapt: [],
      sources: [],
      dynamic_types: [],
      dynamic_sources: [],
      result_band_settings: [],
      rolesFamily: [],
      roles: [],
      //default
      title: "Global Rating",
      active: false,
      action: "",
      name: "",
      description: "",
      method_calculation: "method_avg",
      sorting: -1,
      editing: true,
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    };
  },
  watch: {
    dynamicReAdaptPercent(value) {
      if (value > 100) {
        this.dynamicReAdaptPercent = 100;
      }
      if (value < 0) {
        this.dynamicReAdaptPercent = 0;
      }
    }
  },
  watch: {
    dynamicReAdaptQuestionSurveyZero(value) {
      if (value == "")
        return;

      this.questionSurveyZeroQuestionName = 1;
    },
  },
  methods: {
    filterSources(sourceFrom, selectedValue) {
      if (sourceFrom == 'questionSurveyZero') {
        return this.sources.filter(source => source.element === selectedValue);
      } else if (sourceFrom == 'questionOption') {
        this.filteredRoles = [];
        this.rolesFamily.forEach(role => {
          if (role.id == selectedValue) {
            this.filteredRoles.push(role);
          }
        });
        return this.filteredRoles;
      }
    },
    deleteRating(rowIndex) {
      Vue.delete(this.result_band_settings, rowIndex);
    },
    addRating() {
      let row = {
        index: this.newBandIndex,
        label: this.newBandLabel
      };
      this.result_band_settings.push(row);
      this.newBandIndex = 0;
      this.newBandLabel = "";
    },
    rmReAdaptRow(index) {
      Vue.delete(this.reAdapt, index);
    },
    rmDynamicReAdaptRow(index) {
      Vue.delete(this.dynamicReAdapt, index);
    },
    addReAdaptRow() {
      if (
        (this.newReAdaptQuestionSurveyZero === null || this.newReAdaptQuestionSurveyZero === "") ||
        (this.newReAdaptQuestionSurveyCover === null || this.newReAdaptQuestionSurveyCover === "") ||
        (this.newReAdaptPercent === null || this.newReAdaptPercent === "")
      ) {
        return Vue.swal.fire(this.__("forms.EvaluationChart.questions.questions_setting.question29.alert_messages.allFieldsRequired"));;
      }

      let row = {
        questionSurveyZero: this.newReAdaptQuestionSurveyZero,
        questionSurveyCover: this.newReAdaptQuestionSurveyCover,
        questionSurveyPercent: this.newReAdaptPercent,
      };

      this.reAdapt.push(row);
      //clean
      this.newReAdaptQuestionSurveyZero = null;
      this.newReAdaptQuestionSurveyCover = null;
      this.newReAdaptPercent = null;

    },
    addDynamicReAdaptRow() {
      if (
        (this.dynamicReAdaptType === null || this.dynamicReAdaptType === "") ||
        (this.dynamicReAdaptOption === null || this.dynamicReAdaptOption === "")
      ) {
        return Vue.swal.fire(this.__("forms.EvaluationChart.questions.questions_setting.question29.alert_messages.allFieldsRequired"));
      }

      this.sources.forEach(obj => {
        let skip = false;
        if (this.dynamicReAdapt.length > 0) {
          this.dynamicReAdapt.forEach(objDynamicReAdapt => {
            if (objDynamicReAdapt.questionSurveyZero == obj.element
              && objDynamicReAdapt.questionType == this.dynamicReAdaptType
              && objDynamicReAdapt.questionOption == this.dynamicReAdaptOption) {
              skip = true;
            }
          })
        }
        if (obj.selected && skip == false) {
          let row = {
            questionSurveyZero: obj.element,
            questionType: this.dynamicReAdaptType,
            questionOption: this.dynamicReAdaptOption,
            questionSurveyPercent: null,
          };

          this.dynamicReAdapt.push(row);
        }
      });

      this.dynamicReAdapt.sort(function (a, b) {
        return a.questionOption - b.questionOption;
      })

      //clean
      this.dynamicReAdaptQuestionSurveyZero = null;
      this.dynamicReAdaptType = null;
      this.dynamicReAdaptOption = null;
      this.dynamicReAdaptPercent = null;
    },
    goToStep(stepId, reloadPage) {

      let formDataSerialized = $("#question29Form").serialize();
      let route = $("#question29Form").attr("action");

      axios.put(route,
        {
          questionBase: {

            name: this.name,
            description: this.description,
            sorting: this.sorting
          },
          questionSettings: {
            globalRatingConfig: formDataSerialized,
            oldStep: this.oldStep
          },

        }
      ).then(function (response) {
        //go to next tab
        $("#step-" + stepId).trigger("click");

      }).catch(function (error) {
        console.error("NO", error);
      })
        .finally(function () {

        });
      this.updateOldStep(stepId);
      if (reloadPage) {
        location.reload();
      }
    },
    updateOldStep(stepId) {
      this.oldStep = stepId;
    },
    toggle(action, item_id, editing, attributes) {
      this.active = true;
      this.action = action;
      this.editing = editing;
      this.dataRoute = attributes.dataRoute;
      this.item_id = item_id;

      let dataRoute = decodeURI(attributes.dataRoute);
      if (dataRoute !== undefined) {
        if (dataRoute.indexOf("[id]") > 0) {
          dataRoute = dataRoute.replace("[id]", item_id);
        }
        axios.get(dataRoute).then((response) => {
          this.name = response.data.base.name;
          this.description = response.data.base.description;
          this.sorting = response.data.base.sorting;
          this.repartitioning_min_value = response.data.repartitioning_min_value;
          this.repartitioning_max_value = response.data.repartitioning_max_value;
          this.show_graph = response.data.show_graph;
          this.show_avg = response.data.show_avg;
          this.show_avg_weight = response.data.show_avg_weight;
          this.show_percent_symbol = response.data.show_percent_symbol;
          this.sources = response.data.sources;
          this.dynamic_types = response.data.dynamic_types;
          this.dynamic_sources = response.data.dynamic_sources;
          this.rolesFamily = response.data.dynamic_sources.rolesFamily;
          this.roles = response.data.dynamic_sources.roles;
          this.method_calculation = response.data.method_calculation;
          this.can_write = app.__vue__.questionPermission(this.can_write, response.data.base.enable);
          this.reAdapt = response.data.reAdapt;
          this.dynamicReAdapt = response.data.dynamicReAdapt;
          this.result_band_settings = response.data.result_band_settings;
        });
      }
    },
    handleSourceChange(source) {
      if (source.selected === false) {
        if (this.dynamicReAdapt && this.dynamicReAdapt.length > 0) {
          for (let i = 0; i < this.dynamicReAdapt.length; i++) {
            let objDynamicReAdapt = this.dynamicReAdapt[i];
            if (objDynamicReAdapt.questionSurveyZero === source.element) {
              this.dynamicReAdapt.splice(i, 1);
              i--;
            }
          }
        }
      }
    }
  },
};
</script>
<style>
/* .con-vs-popup .vs-popup{
max-width: 1200px !important;
} */
</style>
